// let header = document.querySelectorAll(".header")[0]
// let headerBtn = document.querySelectorAll(".header__menuBurger")[0]

// headerBtn.addEventListener("click", () => {
//     header.classList.toggle("is-on");
//     if (header.classList.contains("is-on")) {
//         document.body.style.overflowY = "hidden"
//         document.documentElement.style.overflowY = "hidden"
//     } else {
//         document.body.style.overflowY = "auto"
//         document.documentElement.style.overflowY = "auto"
//     }
// })

window.addEventListener("scroll", () => {
    if (window.scrollY >= window.innerHeight * 0.3) {
        document.body.classList.add("notTop")
    } else {
        document.body.classList.remove("notTop")
    }
})